/**
 * Pixel conversions on the right assume a 16px base font-size on the
 * root element. For example, you can assume the 1rem value `fontSize.sm`
 * will render identically to 16px.
 */
var fontSize;

(function (fontSize) {
  fontSize["px12"] = "0.75rem";
  fontSize["px14"] = "0.875rem";
  fontSize["px16"] = "1rem";
  fontSize["px18"] = "1.125rem";
  fontSize["px20"] = "1.25rem";
  fontSize["px22"] = "1.375rem";
  fontSize["px24"] = "1.5rem";
  fontSize["px26"] = "1.625rem";
  fontSize["px28"] = "1.75rem";
  fontSize["px30"] = "1.875rem";
  fontSize["px32"] = "2rem";
  fontSize["px36"] = "2.25rem";
  fontSize["px38"] = "2.5rem";
  fontSize["px42"] = "2.625rem";
  fontSize["px46"] = "2.875rem";
  fontSize["px48"] = "3rem";
  fontSize["px52"] = "3.25rem";
  fontSize["px60"] = "3.75rem";
  fontSize["px66"] = "4.125rem";
  fontSize["px72"] = "4.5rem";
  fontSize["px74"] = "4.625rem";
})(fontSize || (fontSize = {}));

export default fontSize;